.app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  background: var(--blue-light);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.logoLink {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.userInfo {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.userName {
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
}

.logoutButton {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 11px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  padding: 3px 8px !important;
}

.logoutButton:hover {
  color: var(--white) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.title {
  color: var(--white);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.main {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
}

.error {
  background: var(--red-bg);
  color: var(--red);
  padding: 8px 12px;
  border-radius: var(--radius);
  border: 1px solid var(--red-border);
  font-size: 12px;
}

.infoRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 3px;
  font-size: 0.7rem;
  color: var(--gray-text);
}

.infoItem {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.infoSep {
  color: var(--gray-border);
}

.infoWarn {
  color: var(--yellow);
}

/* Compact inline switch affordance, sized to the 0.7rem hint line. Balance's
   button carries min-height/padding that won't collapse this small, so this is
   a plain button styled as a tight pill. */
.switchButton {
  font: inherit;
  line-height: 1.3;
  padding: 0 8px;
  border: 1px solid var(--gray-border);
  border-radius: 999px;
  background: var(--white);
  color: var(--blue-light);
  cursor: pointer;
}

.switchButton:hover {
  border-color: var(--blue-light);
  color: var(--blue);
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  color: var(--gray-text);
  padding: 24px 0;
  font-size: 13px;
}

.spinner {
  width: 22px;
  height: 22px;
  border: 2.5px solid var(--gray-border);
  border-top-color: var(--blue-light);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Respect reduced-motion: stop the spin, keep the indicator visible. */
@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
  }
}
